export default "__VITE_ASSET__DOBd4Z58__"